import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import CustomerUserEntity from "../../../API/customer/CustomerUserEntity";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import CheckFieldUtil from "../../../utils/orders/CustomerUtil";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import CircularProgress from "@mui/material/CircularProgress";
import OrderDatePicker from "../../../components/UI/datepicker/OrderDatePicker";
import dayjs from "dayjs";

const RelatedUsers = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const initValue = {
        name: "",
        email: "",
        registrationNumber: "",
        residentialAddress: "",
        organizationalAndLegalForm: "",
        address: "",
    }
    const [modalOpen, setModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [loading, setLoading] = useState(false)
    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData(initValue)
    }
    const handleEditRow = (row) => {
        setCurrentEditRowData(row);
        setModalOpen(true)
    }

    useEffect(() => {
        getStartPageSize()
        CustomerUserEntity.getByCustomer().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleDelete = (row) => {
        CustomerUserEntity.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const handleEdit = async (data) => {
        const {id, ...values} = data
        CustomerUserEntity.update(id, values)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === id ? response.data : el))
                handleClose()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };
    const handleSubmit = (values) => {
        setLoading(true)
        CustomerUserEntity.save(values.email).then(function (response) {
            handleClose()
            handleModalAlert("Запрос отправлен на почту", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => {
            setLoading(false)
        })

    };
    const handleEnabled = (row) => {
        CustomerUserEntity.updateUnable(row.id, !row.enabled).then(function (response) {
            setData(prev => prev.map(el => el.id === row.id ? {...el, enabled: !row.enabled} : el));
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }


    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Фамилия', accessorKey: 'lastName', minSize: 100,
                Cell: ({cell, row}) => (
                    <Link to={`/settings/userRoles/${row.original.id}`}>{cell.getValue() || "не установлена"}</Link>),
            },
            {
                header: 'Имя', accessorKey: 'firstName', minSize: 100,
            },
            {
                header: 'Отчество', accessorKey: 'middleName', minSize: 100,
            },
            {
                header: 'День рождения', accessorKey: 'birthday', minSize: 100,
            },
            {
                header: 'Номер телефона', accessorKey: 'phoneNumber', minSize: 100,
            },
            {
                header: 'Должность', accessorKey: 'position', minSize: 100,
            },
            {
                id: 'enabled',
                header: 'Доступен',
                accessorKey: 'enabled',
                Cell: ({cell, row}) => <Checkbox
                    onChange={() => handleEnabled(row.original)}
                    checked={row.original.enabled}
                    sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
                />
            },
        ]

        return baseColumns;

    }, [data]);

    const menuItem = [
        {type: "edit", text: "Изменить", handler: handleEditRow},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (<Box
        sx={{
            overflow: 'auto',
            maxWidth: 'calc(100vw - 410px)',
        }}
    >
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>Связаные пользователели</Typography>
            <ButtonCreate
                text={"Привязать другого пользователя"}
                width={300}
                onClick={() => setModalOpen(true)}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '1500px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps ={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions,}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <AddUserModal
            open={modalOpen}
            columns={columns}
            onClose={handleClose}
            initValue={currentEditRowData}
            onSubmit={currentEditRowData.id ? handleEdit : handleSubmit}
            loading={loading}
        />
    </Box>);
};

function Loading() {
    return null;
}

export const AddUserModal = ({open, columns, onClose, onSubmit, initValue, loading}) => {

    const [values, setValues] = useState(initValue);

    useEffect(() => {
        setValues(initValue)
    }, [initValue])

    return (
        <Dialog open={open}>
            <DialogTitle
                textAlign="center">{initValue.id ? "Изменить" : "Добавить работника"}</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                        }}
                    >{initValue.id ? columns.map((column) => (
                        column.accessorKey === "birthday"
                            ? <OrderDatePicker
                                key={column.accessorKey}
                                label={column.header}
                                date={values[column.accessorKey] || ""}
                                setDate={(res) => setValues((prev) => ({
                                    ...prev,
                                    birthday: dayjs(res).format('YYYY-MM-DD')
                                }))}/>
                            :
                            CheckFieldUtil.worker(column) &&
                            <TextFieldValidation
                                key={column.accessorKey}
                                name={column.accessorKey}
                                label={column.header}
                                value={values[column.accessorKey]}
                                required={false}
                                setCurrValues={setValues}
                            />)) : <TextFieldValidation
                        key={"email"}
                        name={"email"}
                        label={"E-mail"}
                        value={values["email"]}
                        required={false}
                        setCurrValues={setValues}
                    />}
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                {loading && <CircularProgress disableShrink/>}
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd text={initValue.id ? "Сохранить" : "Добавить"} onClick={() => onSubmit(values)}
                           disabled={loading}/>
            </DialogActions>
        </Dialog>
    );
};
export default RelatedUsers;